import { InputModel } from '../../../../../../utils/types'

export const initialValues = {
  companies: {
    label: 'general.tags.companies',
    translate: true,
    name: 'companies',
    type: 'filter-select',
    items: [],
    value: null,
  },
  stores: {
    label: 'general.tags.stores',
    translate: true,
    name: 'stores',
    type: 'filter-select',
    items: [],
    value: null,
  },
  roles: {
    label: 'general.tags.roles',
    translate: true,
    name: 'roles',
    type: 'filter-select',
    items: [],
    value: null,
  },
  users: {
    label: 'general.tags.users',
    translate: true,
    name: 'users',
    type: 'filter-select',
    items: [],
    value: null,
  },
  userType: {
    label: 'general.tags.userType',
    translate: true,
    name: 'userType',
    type: 'filter-select',
    items: [],
    value: null,
  },
  divisions: {
    label: 'general.tags.divisions',
    translate: true,
    name: 'divisions',
    type: 'filter-select',
    items: [],
    value: null,
    size: {
      xl: 12,
      lg: 12,
      md: 12,
      sm: 12,
    },
  },
  questionnaires: {
    label: 'general.tags.questionnaires',
    translate: true,
    name: 'questionnaires',
    type: 'filter-select',
    items: [],
    value: null,
  },
  area: {
    label: 'Areas',
    name: 'area',
    type: 'filter-select',
    validate: {
      required: false,
    },
    items: [],
    value: null,
  },
  department: {
    label: 'Departamentos',
    name: 'department',
    type: 'filter-select',
    validate: {
      required: false,
    },
    items: [],
    value: null,
  },
} as { [x: string]: InputModel }
